import { Handle, NodeProps, Position } from 'reactflow';
import { IFactNodeData } from './types';
import { ReactFlowNode } from './SchemaEntityRelationsUI';
import ViewFieldsTable from './ViewFieldsTable';
import ViewHeader from './ViewHeader';
import { useCallback, useState } from 'react';
import { getTableFromKey } from '../utils';
import ExpandCollapseButton from './ExpandCollapseButton';
import ThinDivider from '../../../../components/ThinDivider';
import styled from 'styled-components';

const StyledThinDivider = styled(ThinDivider)`
  margin-top: 8px;
`;

const FactNode = ({ data }: NodeProps<IFactNodeData>) => {
  const {
    viewKey,
    dataModel,
    fields,
    leftHandleId,
    rightHandleId,
    viewTables,
    derivedFields,
  } = data;
  const [expanded, setExpanded] = useState(false);
  const handleToggleExpanded = useCallback(
    () => setExpanded((prevState) => !prevState),
    [],
  );

  const tableNameFunc = useCallback(
    (tableKey: string) => {
      return getTableFromKey(tableKey, dataModel).name;
    },
    [dataModel],
  );

  return (
    <ReactFlowNode>
      {dataModel.dimensions.length > 0 && (
        <Handle type="source" position={Position.Right} id={rightHandleId} />
      )}
      {dataModel.dimensions.length > 1 && (
        <Handle type="source" position={Position.Left} id={leftHandleId} />
      )}
      <ViewHeader viewKey={viewKey} viewTables={viewTables} />
      <ViewFieldsTable
        expanded={expanded}
        fields={fields}
        tableNameFunc={tableNameFunc}
      />
      {derivedFields.length > 0 && (
        <>
          <StyledThinDivider layout="horizontal" size="full" />
          <ViewFieldsTable
            expanded={expanded}
            fields={derivedFields}
            tableNameFunc={tableNameFunc}
          />
        </>
      )}
      {fields.length > 0 && (
        <ExpandCollapseButton
          expanded={expanded}
          onClick={handleToggleExpanded}
        />
      )}
    </ReactFlowNode>
  );
};

export default FactNode;
